import {withStyles} from "@mui/styles";
import {TextField} from "@mui/material";

const NautilusTextInput = withStyles({
    root: {
        backgroundColor: 'white',
        '& .MuiInputBase-input': {
            fontSize: '1.6rem',
            height: '2em',
        },
        '& .MuiFormLabel-root': {
            fontSize: '1.6rem',
        },
        '& label.Mui-focused': {
            color: '#1ebce7',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1ebce7',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            // '& fieldset': {
            //     borderColor: 'red',
            // },
            '&:hover fieldset': {
                borderColor: '#1ebce7',
            },
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: '#1ebce7',
                    '& legend': {
                        padding: '3px'
                    }
                }
            },
            '&.Mui-focused .MuiSelect-select fieldset': {
                '& legend': {
                    padding: '0'
                }
            },
        },
    },
})(TextField);

export default NautilusTextInput;